/**
 * E98.F5.T10 / E98.F7.T07 — a chave do contrato que o catálogo de textos não pode repetir.
 *
 * Três chaves do kit de veículos (os campos da nota fiscal e o item do bem financiado) trazem no
 * nome um termo que o catálogo pt-BR não pode conter, nem como chave: o teste de neutralidade lê
 * o catálogo inteiro, chaves incluídas. O contrato com o servidor não muda; o rótulo mora sob outra
 * chave, e a tela traduz aqui, num ponto só.
 */
export const CHAVE_DO_ROTULO: Readonly<Record<string, string>> = {
  marca_modelo: 'marca_e_versao',
  ano_modelo: 'ano_mod',
  bem_marca_modelo: 'bem_marca_e_versao',
};

/** A chave do catálogo para a chave do contrato; a mesma quando não há tradução. */
export function chaveDoRotulo(chave: string): string {
  return CHAVE_DO_ROTULO[chave] ?? chave;
}
